module.exports = __webpack_public_path__ + "img/info-item-3.84a08186.png";